import { render, staticRenderFns } from "./campanias.vue?vue&type=template&id=07081de8&scoped=true"
import script from "./campanias.vue?vue&type=script&lang=js"
export * from "./campanias.vue?vue&type=script&lang=js"
import style0 from "./campanias.vue?vue&type=style&index=0&id=07081de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07081de8",
  null
  
)

export default component.exports